import {ReactElement} from 'react';
import {Project} from 'interfaces/Project';
import ProjectHeaderView from './ProjectHeaderView';

type Props = {
  project: Project;
};

export default function ProjectHeader({project}: Props): ReactElement {
  return <ProjectHeaderView project={project} />;
}
